import { render } from "./MobileProductsView.vue?vue&type=template&id=1ca01a87&scoped=true"
import script from "./MobileProductsView.vue?vue&type=script&lang=js"
export * from "./MobileProductsView.vue?vue&type=script&lang=js"

import "./MobileProductsView.vue?vue&type=style&index=0&id=1ca01a87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca01a87"]])

export default __exports__